import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { BusinessLicense } from 'types/Documents';

export const useBusinessLicence = (id: string | null) =>
  useDocumentDetails<Document<BusinessLicense> | null>(id);
